import template from "./index.html";
import "./index.less";
import moment from "moment";

import {
	CURSOR_DIRECTIONS, 
	EXPORT_STATUSES, 
	FILTER_OPERATORS 
} from "../../constants";
import { FORM_REPORTS_BY_ID } from "../../../../routes";
import reportExportActions from "./report-export-actions/report-export-actions";

export function controller(appState, entityManager, loadingService, api, $window, $logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.formConfig = appState.forms.selected;
		ctrl.entityLabel = entityManager.primaryFieldLabel;
		
		const primaryDateField = ctrl.formConfig.Fields.find(f => f.IsPrimary === true && f.Type.Code === "DATE");
		ctrl.dateLabel = primaryDateField.Name;

		ctrl.includedReports = [];
		ctrl.includedNegatives = [];

		loadingService.watch(loadReports());
	};

	ctrl.viewReport = (reportId) => {
		$window.open(`/report?id=${reportId}`, "_blank");
	};

	async function loadReports() {
		const ids = ctrl.exportLog.Reports.map(r => r.Report.Id);
		const Filter = {
			Id: { [FILTER_OPERATORS.in.code]: ids }
		};
		const Cursor = {
			Count: ids.length,
			Direction: CURSOR_DIRECTIONS.forward.code
		};
		const request = {
			Filter, 
			Cursor
		};
				
		const reports = await api.post(FORM_REPORTS_BY_ID(ctrl.formConfig.Id), request);

		const augmentedReports = (reports.Items ?? [])
			.map(r => {
				const friendly = entityManager.getFriendlyForPrimaryId(r.EntityId);
				let primary = friendly;

				if(friendly.Entities !== undefined) {
					primary = friendly?.Entities?.find(e => e.Entity.Id === r.EntityId)?.Entity;
				}
				const thisEntity = { primary, friendly };
				const exportReport = ctrl.exportLog.Reports.find(elr => elr.Report.Id === r.Id);

				return {
					...r,
					entity: thisEntity,
					isSelected: true,
					export: exportReport,
					status: exportReport.IsCommitted === true ? EXPORT_STATUSES.committed
						: exportReport.Errors?.length > 0 ? EXPORT_STATUSES.errored
						: exportReport.IsSuppressed === true ? EXPORT_STATUSES.suppressed
						: EXPORT_STATUSES.pending
				};
			});

		ctrl.includedReports = augmentedReports.filter(r => r.IsNegative !== true);
		ctrl.includedNegatives = augmentedReports.filter(r => r.IsNegative === true)
			.map(r => {
				const periodIds = r.Periods.map(p => p.Id);
				const seasonPeriod = {};
				for(const season of ctrl.formConfig.Seasons) {
					const matchingPeriod = season.Periods.find(p => periodIds.indexOf(p.Id) > -1);
					if(matchingPeriod !== undefined) {
						seasonPeriod.season = season;
						seasonPeriod.period = matchingPeriod;
						
						break;
					}
				}

				const begin = moment(seasonPeriod.period.BeginInclusive).format("MM-DD-yyyy HH:mm");
				const end = moment(seasonPeriod.period.EndExclusive).format("MM-DD-yyyy HH:mm");
				const periodLabel = `${seasonPeriod.season.Code} - ${seasonPeriod.period.Name}`;
				const periodRange = `${begin} - ${end}`;

				return {
					...r,
					periodLabel, 
					periodRange
				};
			});

		return {
			reports: ctrl.includedReports,
			negatives: ctrl.includedNegatives
		};
	}
}

export const reportsTab = angular.module("vesl.components.exports.view-export.reports-tab", [reportExportActions])
	.component("reportsTab", {
		controller,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
